import { render, staticRenderFns } from "./editStudent.vue?vue&type=template&id=c0ee6ca6&scoped=true"
import script from "./editStudent.vue?vue&type=script&lang=js"
export * from "./editStudent.vue?vue&type=script&lang=js"
import style0 from "./editStudent.vue?vue&type=style&index=0&id=c0ee6ca6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ee6ca6",
  null
  
)

export default component.exports